const NOTIFICATION_TYPES = {
	/** Отсутствие данных GPS, когда ожидается работа */
	TELEMATICS_NO_GPS_DATA_WHEN_WORK_EXPECTED: 'telematics_no_gps_data_when_work_expected',

	/** Нарушение качества работ */
	WORK_ORDER_QUALITY_ISSUE: 'work_order_quality_issue',

	/** Движение по полю без наряда */
	MOVING_ON_FIELD_WITHOUT_WORK_ORDER: 'moving_on_field_without_work_order',

	/** Включения шнека, когда в радиусе 15 метров нет другой грузовой техники или перегрузчика */
	USING_SCREW_WITHOUT_MACHINE_NEARBY_15M: 'using_screw_without_machine_nearby_15m',

	/** Уменьшение уровня датчика сыпучих без включения шнека */
	DECREASING_BUNKER_SENSOR_LEVEL_WITHOUT_USING_SCREW: 'decreasing_bunker_sensor_level_without_using_screw',

	/** Включения датчика шнека без идентификации водителя */
	USING_SCREW_WITHOUT_IDENTIFICATION: 'using_screw_without_identification',

	/** Слив топлива */
	FUEL_DRAIN: 'fuel_drain',

	/** Длительная остановка, когда ожидается работа */
	LONG_STOP_WHEN_WORK_EXPECTED: 'long_stop_when_work_expected',

	/** Отчет по полевым работам */
	FIELD_WORKS_SUMMARY_REPORT: 'field_works_summary_report',
}
Object.freeze(NOTIFICATION_TYPES)

const NOTIFICATION_IMPORTANCE_LEVELS = {
	INFO: 'info',
	WARNING: 'warning',
	ALERT: 'alert',
}
Object.freeze(NOTIFICATION_IMPORTANCE_LEVELS)

const NOTIFICATION_CATEGORIES = {
	ACCOUNTING: 'accounting',
	DEVICES_AND_SENSORS: 'devices_and_sensors',
	WORKS: 'works',
	INFRASTRUCTURE_EVENTS: 'infrastructure_events',
	SYSTEM: 'system',
	INCIDENTS: 'incidents',
	OTHER: 'other',
}
Object.freeze(NOTIFICATION_CATEGORIES)

export {
	NOTIFICATION_TYPES,
	NOTIFICATION_IMPORTANCE_LEVELS,
	NOTIFICATION_CATEGORIES,
}
